import axios from 'axios';

const BASE_URL_REPLIERS = process.env.REACT_APP_REPLIERS_URL;
const BLOG_URL_STRAPI = process.env.REACT_APP_STARPI_URL;

const BASE_URL = `${BASE_URL_REPLIERS}`;
const BLOG_URL = `${BLOG_URL_STRAPI}/api`



export const fetchRequest = async (url, method = 'GET', data = null) => {
  try {
    const config = {
      method: method,
      url: url,
      data: data,
    };

    const response = await axios(config);
    return response;
  }  catch (error) {
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data.message || 'Server error',
        data: error.response.data,
      };
    } else if (error.request) {
      throw {
        status: null,
        message: 'No response received from the servers',
      };
    } else {
      throw {
        status: null,
        message: `Error: ${error.message}`,
      };
    }
  }
};

export const getListings = async (pageNumber, resultsPerPage, Queries) => {
  const url = `${BASE_URL}/listings?pageNumber=${pageNumber}&resultsPerPage=${resultsPerPage}${Queries}`;
  return await fetchRequest(url);
};

export const getMapListings = async (polygon) => {
  const url = `${BASE_URL}/map?polygon=${polygon}`;
  return await fetchRequest(url);
};

export const getSingleListing = async (id) => {
  const url = `${BASE_URL}/listings/${id}`;
  return await fetchRequest(url);
};

export const getSimilarListings = async (id) => {
  const url = `${BASE_URL}/similar/${id}`;
  return await fetchRequest(url);
};

export const getSearchListings = async (search) => {
  const url = `${BASE_URL}/filter?search=${search}`;
  return await fetchRequest(url);
};

export const googleLogin = async (data) => {
  const url = `${BASE_URL}/auth/googleLogin`;
  return await fetchRequest(url, 'POST', data);
};

export const signInService = async (data) => {
  const url = `/auth/signup`;
  return await fetchRequest(url, 'POST', data)
}

export const loginService = async (data) => {
  const url = `/auth/login`;
  return await fetchRequest(url, 'POST', data)
}
export const getAllBlogs = async ()=>{
  const url = `${BLOG_URL}/blogs?populate[contents][populate]=image`;
  return await fetchRequest(url)
}

export const getBlogsById = async (id)=>{
  const url = `${BLOG_URL}/blogs?filters[id][$eq]=${id}&populate[contents][populate]=image`
  return await fetchRequest(url)
}